import { doc, getDoc, setDoc, collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { computeLicenseStatus } from '../utils/licenseUtils';

export const LicenseService = {

  async getLicense(organizationId) {
    const ref = doc(db, 'licenses', organizationId);
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    return { organizationId, ...snap.data() };
  },

  async createTrialLicense(organizationId, userId) {
    const now = new Date();
    const trialEndsAt = new Date(now.getTime() + 14 * 24 * 60 * 60 * 1000);
    const license = {
      organizationId,
      plan: 'trial',
      status: 'active',
      trialStartedAt: now,
      trialEndsAt,
      currentPeriodEnd: null,
      overrides: {
        limits: {},
        widgetOverrides: { allow: [], block: [] }
      },
      createdAt: now,
      updatedAt: now,
      updatedBy: userId,
      notes: ''
    };
    const ref = doc(db, 'licenses', organizationId);
    await setDoc(ref, license);
    return computeLicenseStatus(license);
  },

  async updateLicense(organizationId, updates, adminUserId) {
    const ref = doc(db, 'licenses', organizationId);
    await setDoc(ref, { ...updates, updatedAt: new Date(), updatedBy: adminUserId }, { merge: true });
  },

  async getAllPlanDefinitions() {
    const snap = await getDocs(collection(db, 'planDefinitions'));
    const result = {};
    snap.forEach(d => { result[d.id] = d.data(); });
    return result;
  },

  async getActivePromotion() {
    const now = new Date();
    const ref = collection(db, 'promotions');
    const q = query(ref, where('isActive', '==', true));
    const snap = await getDocs(q);
    for (const d of snap.docs) {
      const promo = { id: d.id, ...d.data() };
      const validFrom = promo.validFrom?.toDate ? promo.validFrom.toDate() : new Date(promo.validFrom);
      const validUntil = promo.validUntil?.toDate ? promo.validUntil.toDate() : new Date(promo.validUntil);
      if (validFrom <= now && now <= validUntil) return promo;
    }
    return null;
  },

  async getAdminUids() {
    const ref = doc(db, 'config', 'admins');
    const snap = await getDoc(ref);
    return snap.exists() ? (snap.data().uids || []) : [];
  }
};
